import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=4b388754&scoped=true"
import script from "./role-manage.vue?vue&type=script&lang=js"
export * from "./role-manage.vue?vue&type=script&lang=js"
import style0 from "./role-manage.vue?vue&type=style&index=0&id=4b388754&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b388754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b388754')) {
      api.createRecord('4b388754', component.options)
    } else {
      api.reload('4b388754', component.options)
    }
    module.hot.accept("./role-manage.vue?vue&type=template&id=4b388754&scoped=true", function () {
      api.rerender('4b388754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role-manage.vue"
export default component.exports